import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicOrganisationTrial } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteTrial = async ({
  organisationId,
  trialId,
}: {
  organisationId: string;
  trialId: string;
}): Promise<PublicOrganisationTrial> => {
  const response = await axiosClient.delete(
    `organisation-trials/${organisationId}/${trialId}`,
  );
  return response.data;
};

function useDeleteTrial(
  mutationOptions?: UseMutationOptions<
    PublicOrganisationTrial,
    HttpError,
    { organisationId: string; trialId: string }
  >,
) {
  return useMutation({
    mutationFn: deleteTrial,
    ...mutationOptions,
  });
}

export { useDeleteTrial };
